import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent  {

  numGroups: number;
  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {


 
    
  }

}
